module.exports = __webpack_public_path__ + "static/media/ePosterVideo.4359e6a6.mp4";